import YourData from 'containers/your-data';
import type { NextPage } from 'next/types';

const YourDataPage: NextPage = () => <YourData />;

export default YourDataPage;
